import React from 'react';
import { StaticQuery, graphql } from "gatsby"
import FeatureList from "../../common/featureList/featureList"
import './styles.scss'

const MobileFeatures = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allDataYaml {
            edges {
              node {
                mobilelp {
                  features {
                    title
                    featureComponents {
                      key
                      title
                      description
                      alt
                    }
                  }
                }
                language
              }
            }
          }
          featureIconFile: allFile(filter: {relativePath: {glob: "mobilelp/features/*"}}, sort: {fields: name}) {
            nodes {
              name
              publicURL
            }
          }
        }
      `}
      render={({ allDataYaml: { edges }, featureIconFile }) => {
        const { node: { mobilelp: { features } } } = edges.find(({node}) => node.language === props.language)

        const iconMap = featureIconFile.nodes.reduce((acc, elem) => {
          acc[elem.name] = elem
          return acc
        }, {})

        return <div className="mobile-features mx-auto">
          <h2 className="mobile-features-heading text-center px-5">{features.title}</h2>
          <FeatureList features={features.featureComponents} iconMap={iconMap} />
        </div>
      }}
    />
  )
}

export default MobileFeatures
